/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/heading-has-content */
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
export default function Markdown({ ...other }) {
    return (
        <div className='mt-10 max-w-3xl xl:mx-8 break-words' id='blog-content'>
            <div className=''>
                <ReactMarkdown rehypePlugins={[rehypeRaw]} components={components} {...other} />
            </div>
        </div>
    )
}

const components = {
    h1: ({ ...props }) => <h1 className='font-Karla text-2xl font-bold pt-10 pb-5 w-full' {...props} />,
    h2: ({ ...props }) => <h2 className='font-Karla text-xl font-semibold pt-12 pb-2' {...props} />,
    h3: ({ ...props }) => <h3 className='font-Karla text-lg font-semibold py-1' {...props} />,
    h4: ({ ...props }) => <h4 className='font-Karla text-md font-medium py-1' {...props} />,
    h5: ({ ...props }) => <h5 className='text-lg font-medium py-1' {...props} />,
    h6: ({ ...props }) => <h6 className='text-base font-medium py-1' {...props} />,
    hr: ({ ...props }) => <hr className='my-3 border-t border-gray-300' {...props} />,
    img: ({ ...props }) => <img className='rounded-lg my-5' alt={props.alt} {...props} />,
    p: ({ ...props }) => <p className='font-Karla text-lg leading-7 my-5' {...props} />,
    ul: ({ ...props }) => <ul className='font-Karla list-disc pl-5 my-2' {...props} />,
    ol: ({ ...props }) => <ol className='font-Karla list-decimal pl-5 my-3' {...props} />,
    li: ({ ...props }) => <li className='font-Karla text-lg leading-7 py-2' {...props} />,
    strong: ({ ...props }) => <strong className='font-Karla font-semibold' {...props} />,
    a: ({ ...props }) =>
        props.href.includes('http') ? (
            <a className='text-blue-500 hover:underline' target='_blank' rel='noopener noreferrer' {...props} />
        ) : (
            <a className='text-blue-500 hover:underline' {...props} />
        )
}

export function MarkdownSmall({ ...other }) {
    return (
        <>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={componentsSmall} {...other} />
        </>
    )
}

const componentsSmall = {
    h1: ({ ...props }) => <h1 className='font-Karla text-2xl font-bold pt-10 pb-5' {...props} />,
    h2: ({ ...props }) => <h2 className='font-Karla text-2xl font-semibold pt-12 pb-2' {...props} />,
    h3: ({ ...props }) => <h3 className='font-Karla text-2xl font-semibold py-1' {...props} />,
    h4: ({ ...props }) => <h4 className='font-Karla text-xl font-medium py-1' {...props} />,
    h5: ({ ...props }) => <h5 className='text-lg font-medium py-1' {...props} />,
    h6: ({ ...props }) => <h6 className='text-base font-medium py-1' {...props} />,
    hr: ({ ...props }) => <hr className='my-3 border-t border-gray-300' {...props} />,
    img: ({ ...props }) => <img className='rounded-lg my-5' alt={props.alt} {...props} />,
    p: ({ ...props }) => <p className='text-md leading-7 my-2' {...props} />,
    ul: ({ ...props }) => <ul className='font-Karla list-disc pl-5 my-1' {...props} />,
    ol: ({ ...props }) => <ol className='font-Karla list-decimal pl-5 ' {...props} />,
    li: ({ ...props }) => <li className='font-Karla text-md leading-7 ' {...props} />,
    strong: ({ ...props }) => <strong className='font-Karla font-semibold' {...props} />,
    a: ({ ...props }) =>
        props.href.includes('http') ? (
            <a className='text-blue-500 hover:underline' target='_blank' rel='noopener noreferrer' {...props} />
        ) : (
            <a className='text-blue-500 hover:underline' {...props} />
        )
}
export function MarkdownXSmall({ ...other }) {
    return (
        <>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={componentsXSmall} {...other} />
        </>
    )
}

const componentsXSmall = {
    h1: ({ ...props }) => <h1 className='font-Karla text-2xl font-bold pt-10 pb-5' {...props} />,
    h2: ({ ...props }) => <h2 className='font-Karla text-2xl font-semibold pt-12 pb-2' {...props} />,
    h3: ({ ...props }) => <h3 className='font-Karla text-2xl font-semibold py-1' {...props} />,
    h4: ({ ...props }) => <h4 className='font-Karla text-xl font-medium py-1' {...props} />,
    h5: ({ ...props }) => <h5 className='text-lg font-medium py-1' {...props} />,
    h6: ({ ...props }) => <h6 className='text-base font-medium py-1' {...props} />,
    hr: ({ ...props }) => <hr className='my-3 border-t border-gray-300' {...props} />,
    img: ({ ...props }) => <img className='rounded-lg my-5' alt={props.alt} {...props} />,
    p: ({ ...props }) => <p className='text-xs leading-4 my-0' {...props} />,
    ul: ({ ...props }) => <ul className='font-Karla list-disc pl-5 my-1' {...props} />,
    ol: ({ ...props }) => <ol className='font-Karla list-decimal pl-5 ' {...props} />,
    li: ({ ...props }) => <li className='font-Karla text-md leading-7 ' {...props} />,
    strong: ({ ...props }) => <strong className='font-Karla font-semibold' {...props} />,
    a: ({ ...props }) =>
        props.href.includes('http') ? (
            <a className='text-blue-500 hover:underline' target='_blank' rel='noopener noreferrer' {...props} />
        ) : (
            <a className='text-blue-500 hover:underline' {...props} />
        )
}
export function MarkdownSmallCell({ ...other }) {
    return (
        <>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={componentsCell} {...other} />
        </>
    )
}
const ToolSmall = {
    h1: ({ ...props }) => <h1 className='font-Karla text-sm font-bold ' {...props} />,
    h2: ({ ...props }) => <h2 className='font-Karla text-sm font-bold ' {...props} />,
    h3: ({ ...props }) => <h3 className='font-Karla text-sm font-bold ' {...props} />,
    h4: ({ ...props }) => <h4 className='font-Karla text-sm font-bold ' {...props} />,
    h5: ({ ...props }) => <h5 className='text-sm font-bold ' {...props} />,
    h6: ({ ...props }) => <h6 className='text-sm font-bold ' {...props} />,
    hr: ({ ...props }) => <hr className='my-1 border-t border-gray-300' {...props} />,
    img: ({ ...props }) => null,
    p: ({ ...props }) => <p className='text-xs  my-0' {...props} />,
    ul: ({ ...props }) => <ul className='text-xs font-Karla list-disc pl-2 my-0' {...props} />,
    ol: ({ ...props }) => <ol className='text-xs font-Karla list-decimal pl-2 ' {...props} />,
    li: ({ ...props }) => <li className='text-xs font-Karla text-xs leading-3 ' {...props} />,
    strong: ({ ...props }) => <strong className='text-xs font-Karla font-semibold' {...props} />,
    a: ({ ...props }) =>
        props.href.includes('http') ? (
            <a className='text-blue-500 hover:underline' target='_blank' rel='noopener noreferrer' {...props} />
        ) : (
            <a className='text-blue-500 hover:underline' {...props} />
        )
}
export function MarkdownToolSmall({ ...other }) {
    return (
        <>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={ToolSmall} {...other} />
        </>
    )
}

const componentsCell = {
    h1: ({ ...props }) => <h1 className='font-Karla text-xl font-bold pt-2 pb-1' {...props} />,
    h2: ({ ...props }) => <h2 className='font-Karla text-md font-semibold pt-1 pb-2' {...props} />,
    h3: ({ ...props }) => <h3 className='font-Karla text-md font-semibold py-1' {...props} />,
    h4: ({ ...props }) => <h4 className='font-Karla text-md font-medium py-1' {...props} />,
    h5: ({ ...props }) => <h5 className='text-lg font-medium py-1' {...props} />,
    h6: ({ ...props }) => <h6 className='text-base font-medium py-1' {...props} />,
    hr: ({ ...props }) => <hr className='my-3 border-t border-gray-300' {...props} />,
    img: ({ ...props }) => <img className='rounded-lg my-5' alt={props.alt} {...props} />,
    p: ({ ...props }) => <p className='text-md leading-7 my-2' {...props} />,
    ul: ({ ...props }) => <ul className='font-Karla list-disc pl-5 my-1' {...props} />,
    ol: ({ ...props }) => <ol className='font-Karla list-decimal pl-5 ' {...props} />,
    li: ({ ...props }) => <li className='font-Karla text-md leading-7 ' {...props} />,
    strong: ({ ...props }) => <strong className='font-Karla font-semibold' {...props} />,
    a: ({ ...props }) =>
        props.href.includes('http') ? (
            <a className='text-blue-500 hover:underline' target='_blank' rel='noopener noreferrer' {...props} />
        ) : (
            <a className='text-blue-500 hover:underline' {...props} />
        )
}
export function MarkdownSmallBot({ ...other }) {
    return (
        <>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} components={componentsCellBot} {...other} />
        </>
    )
}

const componentsCellBot = {
    h1: ({ ...props }) => <h1 className='font-Karla text-xl font-bold pt-2 pb-1' {...props} />,
    h2: ({ ...props }) => <h2 className='font-Karla text-md font-semibold pt-1 pb-2' {...props} />,
    h3: ({ ...props }) => <h3 className='font-Karla text-md font-semibold py-1' {...props} />,
    h4: ({ ...props }) => <h4 className='font-Karla text-md font-medium py-1' {...props} />,
    h5: ({ ...props }) => <h5 className='text-lg font-medium py-1' {...props} />,
    h6: ({ ...props }) => <h6 className='text-base font-medium py-1' {...props} />,
    hr: ({ ...props }) => <hr className='my-3 border-t border-gray-300' {...props} />,
    img: ({ ...props }) => <img className='rounded-lg my-5' alt={props.alt} {...props} />,
    p: ({ ...props }) => <p className='text-xs leading-5 my-1 text-gray-600' {...props} />,
    ul: ({ ...props }) => <ul className='font-Karla list-disc pl-5 my-1' {...props} />,
    ol: ({ ...props }) => <ol className='font-Karla list-decimal pl-5 ' {...props} />,
    li: ({ ...props }) => <li className='font-Karla text-xs leading-5 text-gray-600 ' {...props} />,
    strong: ({ ...props }) => <strong className='font-Karla font-semibold' {...props} />,
    a: ({ ...props }) =>
        props.href.includes('http') ? (
            <a className='text-blue-500 hover:underline' target='_blank' rel='noopener noreferrer' {...props} />
        ) : (
            <a className='text-blue-500 hover:underline' {...props} />
        )
}
